export enum KnmRegistryActionsEnum {
  KNM_REGISTRY_SET_DATA = 'KNM_REGISTRY_SET_DATA',
  KNM_REGISTRY_GET_DATA = 'KNM_REGISTRY_GET_DATA',
  KNM_REGISTRY_EXPORT = 'KNM_REGISTRY_EXPORT',
}
